// extracted by mini-css-extract-plugin
export default {"modal":"_1jahi0Py","backdrop":"_3_s0-NfC","overlay":"m2cyDjP8","keyboardMode":"_1IUe_4By"};